import Input from 'components/common/form/input/Input';
import { Form, Formik } from 'formik';
import React from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { InstitutionProfileFormValue, Props } from './institutionProfile.type';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';
import { useUpdateInstitutionProfileMutation } from 'service/authQuery/authQuery';
import { useNavigate } from 'react-router-dom';

const validationSchema = Yup.object().shape({
  contactPersonName: Yup.string().required('Contact person name is required'),
  contactPersonDesignation: Yup.string().required(
    'Contact person designation is required'
  ),
  contactEmail: Yup.string()
    .email('Invalid email format')
    .required('Contact email is required'),
  contactPhoneNumber: Yup.string()
    .required('Contact phone number is required')
    .matches(
      /^\+?[1-9]\d{1,14}$/,
      'Phone number must include a country code and be valid'
    ),
  username: Yup.string().required('Institution name is required'),
  address: Yup.string().required('Address is required'),
  year: Yup.number()
    .required('Year Established is required')
    .min(1900, 'Year Established must be after 1900')
    .max(new Date().getFullYear(), 'Year Established cannot be in the future')
});

function InstitutionProfile({ innerRef }: Props) {
  const data = useSelector((state: RootState) => state.user.user);
  const [updateInstitution] = useUpdateInstitutionProfileMutation();

  const navigate = useNavigate();

  const handleSubmit = async (values: InstitutionProfileFormValue) => {
    try {
      await updateInstitution(values);
      navigate(-1);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="mb-5">
      <Formik
        innerRef={innerRef}
        initialValues={{
          username: data.username ?? '',
          year: data.info.year ?? '',
          address:
            typeof data.info.address === 'string' ? data.info.address : '',
          contactPersonName: data.info.contactPersonName ?? '',
          contactPersonDesignation: data.info.contactPersonDesignation ?? '',
          contactEmail: data.info.contactEmail ?? '',
          contactPhoneNumber: data.info.contactPhoneNumber ?? ''
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form>
          <Row className="g-5">
            <Col xs={12} xl={3}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="username">Institution Name</FormLabel>
                <Input name="username" id="username" />
              </FormGroup>
            </Col>
            <Col xs={12} xl={3}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="year">Year Established</FormLabel>
                <Input name="year" id="year" />
              </FormGroup>
            </Col>
            <Col xs={12} xl={6}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="address">Address</FormLabel>
                <Input name="address" id="address" />
              </FormGroup>
            </Col>
            <Col xs={12} xl={4}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="contactPersonName">
                  Contact Person Name
                </FormLabel>
                <Input
                  name="contactPersonName"
                  id="contactPersonName"
                  placeholder="Ex: John"
                />
              </FormGroup>
            </Col>
            <Col xs={12} xl={4}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="contactEmail">
                  Contact Person Email
                </FormLabel>
                <Input
                  name="contactEmail"
                  id="contactEmail"
                  type="email"
                  placeholder="name@example.com"
                />
              </FormGroup>
            </Col>
            <Col xs={12} xl={4}>
              <FormGroup className="text-start">
                <FormLabel htmlFor="contactPersonDesignation">
                  Contact Person Designation
                </FormLabel>
                <Input
                  name="contactPersonDesignation"
                  id="contactPersonDesignation"
                />
              </FormGroup>
            </Col>
            <Col xs={12} xl={4}>
              <FormGroup className="mb-3 text-start">
                <FormLabel htmlFor="contactPhoneNumber">
                  Contact Person Phone Number
                </FormLabel>
                <Input name="contactPhoneNumber" id="contactPhoneNumber" />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </Formik>
    </div>
  );
}

export default InstitutionProfile;
